
export const GETORDER_LOADING ="getorder/loading";
export const GETORDER_SUCCESS ="getorder/success";
export const GETORDER_ERROR ="getorder/error";

